<template>
    <div class="modal-recharge">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">选择入住老人</div>
                <div style="folat:right">
                    <el-button type="danger" @click="closeSelf">关闭</el-button>
                </div>
            </div>
            <div class="modal-body" :style="bodyStyle">
                <el-row>
                    <el-form :model="searchForm" inline ref="searchForm">
                        <div>
                            <el-col :span="24">
                                <el-form-item prop="name">
                                    <el-input  placeholder="请输入姓名" v-model="searchForm.name" clearable style="width:200px;margin-right:10px"></el-input>
                                </el-form-item>

                                <el-button  type="primary" icon="el-icon-search" @click="getElderly">搜索</el-button>
                            </el-col>
                        </div>
                    </el-form>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span="24">
                        <el-table :data="elderlyInfo" style="width: 100%" border :height="th">
                            <el-table-column label="老人姓名" prop="name" ></el-table-column>
                            <el-table-column label="手机号" prop="phone"></el-table-column>
                            <el-table-column label="身份证号" prop="idCard" ></el-table-column>
                            <el-table-column label="地址" prop="areaName"></el-table-column>
                            <el-table-column label="详细住址" prop="homeAddress"></el-table-column>
                            <el-table-column label="操作" width="150">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click.native.prevent="handleRecharge(scope.row)">充值</el-button>
                                </template>
                            </el-table-column>

                        </el-table>
                    </el-col>
                </el-row>
                <div style="text-align: left;background-color: #fff;padding: 10px;">
                    <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/searchForm.pageSize)}}页）
                    </div>
                    <div style="float: left;">
                        <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="totalItems"
                                :page-size="20"
                                @current-change="current_change">
                        </el-pagination>
                    </div>
                    <div style="clear: both;"></div>
                </div>
            </div>
        </div>

        <el-dialog title='充值' :visible.sync="rechargeDialog" :modal-append-to-body='false' @close='closeRechargeForm' class="dialog" width='400px' center top='30vh' :close-on-click-modal='false'>
            <el-form :model="rechargeForm" :rules="rules" ref="rechargeForm">
                <div>
                    <el-row>
                        <el-col :span="24" class="item">
                            <el-form-item label="充值金额" required prop="money">
                                <el-input v-model="rechargeForm.money" type="number" placeholder="请输入金额"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" class="item">
                            <el-form-item label="充值类型" required prop="rechargeType">
                                <el-select v-model="rechargeForm.rechargeType" placeholder="请选择充值类型" style="width:100%">
                                    <el-option
                                            v-for="item in typeValue"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" class="item">
                            <el-form-item label="备注">
                                <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 2, maxRows: 4}"
                                    placeholder="备注信息"
                                    v-model="rechargeForm.remarks">
                                </el-input>
                            </el-form-item>
                        </el-col>

                    </el-row>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="rechargeDialog=false">取 消</el-button>
                <el-button type="primary"  @click="confirm('rechargeForm')">提交</el-button>
            </div>
        </el-dialog>
        <el-dialog title='充值验证' :visible.sync="verificationDialog" :modal-append-to-body='false' @close='closeVerifiyForm' class="dialog" width='600px' center top='30vh' :close-on-click-modal='false'>
            <el-form :model="verifiyForm" ref="verifiyForm" :rules="verifiyRules">
                <el-row>
                    <el-col :span="12" class="item">
                        <el-form-item label="老人姓名">
                            <el-input v-model="elderlyRow.name" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                        <el-form-item label="充值金额">
                            <el-input v-model="rechargeForm.money" type="number" disabled placeholder="请输入金额"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                        <el-form-item label="充值类型">
                            <el-select v-model="rechargeForm.rechargeType" disabled placeholder="请选择充值类型" style="width:100%">
                                <el-option
                                        v-for="item in typeValue"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                        <el-form-item label="验证金额" required prop="verifiyBalance">
                            <el-input v-model="verifiyForm.verifiyBalance" type="number" placeholder="请输入验证金额"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" >
                <el-button @click="verificationDialog=false">取 消</el-button>
                <el-button type="primary" :loading="loading" @click="addSubmit">提交</el-button>
            </div>
        </el-dialog>


      <el-dialog title='充值凭证' :visible.sync="voucherDialog"
                 :modal-append-to-body='false'
                 width='800px' center top='10vh'
                 :close-on-click-modal='false'>

        <div id="printTest2" v-if="successInfo!=null">
          <div style="padding: 20px;">
            <div style="text-align: center;font-size: 25px;">
              <div>收款收据</div>
            </div>
            <div style="padding: 10px 0px;">
              <div style="float: left;">收款单位：{{insName}}</div>
              <div style="float: right;">日期：{{formatterTime(successInfo.createTime).substring(0,16)}}</div>
              <div style="clear:both;"></div>
            </div>
            <div>
              <table style="width: 100%;height:200px;border: 1px solid #ddd;padding: 0px;border-collapse:collapse;">
                <tr style="height: 50px;">
                  <th style="width: 20%">收费项目名称</th>
                  <th style="width: 20%">收款金额</th>
                  <th style="width: 20%">交款方式</th>
                  <th style="width: 40%">备注</th>
                </tr>
                <tr align="center" style="height: 50px;">
                  <td>备用金充值</td>
                  <td>{{successInfo.money}}</td>
                  <td>{{getType(successInfo.rechargeType)}}</td>
                  <td>{{successInfo.remarks}}</td>
                </tr>
                <tr style="height: 50px">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr style="height: 50px">
                  <td align="right">大写金额：</td>
                  <td colspan="2">{{convertCurrency(successInfo.money)}}</td>
                  <td></td>
                </tr>
              </table>

            </div>
            <div style="padding: 10px 0px;">
              <div style="float: left;">收款单位（盖章）：</div>
              <div style="float: right;">交款人：{{successInfo.elderlyName}}</div>
              <div style="clear:both;"></div>
            </div>

          </div>
        </div>

        <div style="text-align: center">
          <el-button type="info" v-print="'#printTest2'">打印</el-button>
        </div>

      </el-dialog>


    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode, getStaffDTO} from "@/utils/auth";


    export default {
        name: 'Add',
        data() {
            return {
                showModalRecharge:false,
                verificationDialog:false,
                voucherDialog:false,
                rechargeDialog:false,
                verifiyForm:{
                    verifiyBalance:'',
                },
                multipleSelection:'',
                checked:false,
                loading: false,
                elderlyInfo:[],
                elderlyRow:'',

                totalItems:0,

                searchForm:{
                  timeStr:timeStr,
                  sign:'',
                  staffCode:getStaffCode(),
                  name:'',
                  phone:'',
                  checkinStatus:2,
                  pageSize:20,
                  pageIndex:1,
                },

                rechargeForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyCode:'',
                    remarks:'',
                    type:1,
                    money:'',
                    rechargeType:''
                },

              typeValue:[
                {value:1,label:"现金"},
                {value:2,label:"支付宝"},
                {value:3,label:"微信"},
                {value:4,label:"刷卡"},
                {value:5,label:"补贴"},
                {value:6,label:"转账"}
              ],

              rules:{
                    money:[
                        { required: true, message: '请输入金额', trigger: 'blur' },
                        {
                            pattern: /^([0-9]?)+(\.[0-9][0-9]?)?$/,
                            message: "小数点后最多只能输入两位"
                        }
                    ],
                    rechargeType:[
                        { required: true, message: '请选择充值类型', trigger: 'blur' }
                    ],
                },

                verifiyRules:{
                    verifiyBalance:[
                        { required: true, message: '请输入金额', trigger: 'blur' },
                        {
                            pattern: /^([0-9]?)+(\.[0-9][0-9]?)?$/,
                            message: "小数点后最多只能输入两位"
                        }
                    ]
                },

                bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
                th:this.$store.state.tableHeight-30,

                successInfo:'',
              insName:getStaffDTO().institutionDTO.userDTO.name,

            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.bodyStyle = "height:"+(val+50)+'px';
                this.th=val-30
            },
        },
        components:{

        },
        methods: {
            init(){
                this.$refs.searchForm.resetFields()
                this.getElderly()
            },
            formatterTime(cellValue) {
                return timefilters(cellValue)
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            getList(){
                this.$emit("getList");
                this.getElderly();
            },
            current_change:function(currentPage){
                this.searchForm.pageIndex = currentPage;
                this.getElderly();
            },
            handleRecharge(row) {
                this.elderlyRow=row
                this.rechargeForm.elderlyCode=row.elderlyCode
                this.rechargeDialog=true
            },
            closeRechargeForm(){
                this.$refs.rechargeForm.resetFields();
                this.rechargeForm.remarks=''
            },
            closeVerifiyForm(){
                this.loading=false
                this.$refs.verifiyForm.resetFields();
            },

            getType(type){
                let data=''
                this.typeValue.forEach(element => {
                    if(element.value==type){
                        data=element.label
                    }
                });
                return data
            },

            getElderly(){

                this.searchForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.searchForm.timeStr = timeStr
                this.searchForm.staffCode = getStaffCode()

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Elderly/InsPageCheckin",
                    data: this.searchForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.elderlyInfo=response.data.data.pageInfo.list;
                            this.totalItems = response.data.data.pageInfo.total;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },

            confirm(rechargeForm){
                this.$refs[rechargeForm].validate((valid) => {
                    if(valid){
                        this.verificationDialog=true
                    }else {
                        this.$message({type: 'info', message: '请完善信息'});
                        return false;
                    }
                })
            },

            addSubmit(){

                if(this.verifiyForm.verifiyBalance != this.rechargeForm.money){
                    this.$message.error('验证失败，请重新输入验证金额')
                    return;
                }

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.rechargeForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"ImprestRecord/Add",
                    data: this.rechargeForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.rechargeDialog=false
                            this.verificationDialog=false

                            this.voucherDialog=true
                            this.successInfo=response.data.data;
                            this.successInfo.elderlyName = this.elderlyRow.name;

                            this.$emit('getList')

                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },

          convertCurrency(money) {
            //汉字的数字
            var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
            //基本单位
            var cnIntRadice = new Array('', '拾', '佰', '仟');
            //对应整数部分扩展单位
            var cnIntUnits = new Array('', '万', '亿', '兆');
            //对应小数部分单位
            var cnDecUnits = new Array('角', '分', '毫', '厘');
            //整数金额时后面跟的字符
            var cnInteger = '整';
            //整型完以后的单位
            var cnIntLast = '元';
            //最大处理的数字
            var maxNum = 999999999999999.9999;
            //金额整数部分
            var integerNum;
            //金额小数部分
            var decimalNum;
            //输出的中文金额字符串
            var chineseStr = '';
            //分离金额后用的数组，预定义
            var parts;
            // 传入的参数为空情况
            if(money == '') {
              return '';
            }
            money = parseFloat(money)
            if(money >= maxNum){
              return ''
            }
            // 传入的参数为0情况
            if(money == 0) {
              chineseStr = cnNums[0] + cnIntLast + cnInteger;
              return chineseStr
            }
            // 转为字符串
            money = money.toString();
            // indexOf 检测某字符在字符串中首次出现的位置 返回索引值（从0 开始） -1 代表无
            if(money.indexOf('.') == -1){
              integerNum = money;
              decimalNum = ''
            }else{
              parts = money.split('.');
              integerNum = parts[0];
              decimalNum = parts[1].substr(0,4);
            }
            //转换整数部分
            if(parseInt(integerNum,10) > 0){
              let zeroCount  = 0;
              let IntLen = integerNum.length
              for(let i = 0; i < IntLen; i++){
                let n = integerNum.substr(i,1);
                let p = IntLen - i - 1;
                let q = p / 4;
                let m = p % 4;
                if( n == '0'){
                  zeroCount ++ ;
                }else{
                  if(zeroCount > 0){
                    chineseStr += cnNums[0]
                  }
                  zeroCount = 0;
                  chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                }
                if(m == 0 && zeroCount < 4){
                  chineseStr += cnIntUnits[q];
                }
              }
              // 最后+ 元
              chineseStr += cnIntLast;
            }
            // 转换小数部分
            if(decimalNum != ''){
              let decLen = decimalNum.length;
              for(let i = 0; i <decLen; i++){
                let n = decimalNum.substr(i,1);
                if(n != '0'){
                  chineseStr += cnNums[Number(n)] + cnDecUnits[i]
                }
              }
            }
            if(chineseStr == ''){
              chineseStr += cnNums[0] + cnIntLast + cnInteger;
            }else if(decimalNum == ''){
              chineseStr += cnInteger;
            }

            return chineseStr
          },





        }
    }


</script>





<style>
#printTest2 table tr th{
  border: 1px solid #ddd;padding: 0px;margin: 0px;
}
#printTest2 table tr td{
  border: 1px solid #ddd;padding: 0px;margin: 0px;
}
</style>

<style lang="scss" scoped>

    .modal-recharge {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        z-index: 99;
        .dialog /deep/ .is-disabled .el-input__inner {
            background-color: #F5F7FA;
            border-color: #E4E7ED;
            color: #000;
            cursor: not-allowed;
        }
        .text{
            font-size: 16px;
            line-height: 25px;
        }
        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 0;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }

            .modal-body {
                position: relative;
                padding: 20px 20px 0;
                z-index: 99;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-body /deep/ .el-form-item{
                margin: 0 5px 0 0;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
